import { estaContido, validarQtdeCaractere } from './auxiliares';
import { useMetadadosItem } from './useMetadadosItem';

export const useMetadadosTituloSeo = () => {
  const criterios = [
    {
      texto: 'O título SEO deve conter entre 1 e 60 caracteres',
      otimizado: false,
    },
    {
      texto: 'Este campo não pode estar vazio',
      otimizado: false,
    },
    {
      texto: 'O título SEO deve conter a palavra-chave',
      otimizado: false,
    },
  ];

  function validacoes(index, tituloSeo, palavraChave) {
    switch (index) {
      case 0:
        return validarQtdeCaractere(tituloSeo, 1, 60);
      case 1:
        return tituloSeo !== null && tituloSeo !== undefined && tituloSeo.length > 0;
      case 2:
        return estaContido(palavraChave, tituloSeo);
    }
  }

  return useMetadadosItem({ itemCriterios: criterios, validacoesFn: validacoes });
};
